import Seo from "../components/Seo";

const Sitemap = () => {
  return (
    <>
      <Seo
        title="Sitemap | KK Solar"
        description="Explore the main pages of KK Solar including home, about, services, blog, contact, and privacy policy."
        url="https://kksolar.co.in/sitemap"
      />
      <div className="max-w-5xl mt-24 mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Sitemap</h1>
      <p className="text-sm text-gray-500 mb-8">
        Here’s an overview of the important pages on our website.
      </p>

      {/* Main Pages */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Main Pages</h2>
        <ul className="list-non space-y-1">
          <li><a href="/" className="text-blue-600 hover:underline">Home</a></li>
          <li><a href="/about" className="text-blue-600 hover:underline">About Us</a></li>
          <li><a href="/services" className="text-blue-600 hover:underline">Services</a></li>
          <li><a href="/products" className="text-blue-600 hover:underline">Products</a></li>
          <li><a href="/blog" className="text-blue-600 hover:underline">Blog</a></li>
          <li><a href="/contact" className="text-blue-600 hover:underline">Contact Us</a></li>
        </ul>
      </section>

      {/* Legal Pages */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Legal Pages</h2>
        <ul className="list-none space-y-1">
          <li><a href="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</a></li>
        </ul>
      </section>


    </div>
    </>
  );
};

export default Sitemap;
